import { render, staticRenderFns } from "./fieldAutoCompleteColaborator.vue?vue&type=template&id=fbda3796&v-slot%3Aview=true"
import script from "./fieldAutoCompleteColaborator.vue?vue&type=script&lang=js"
export * from "./fieldAutoCompleteColaborator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports